var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('div',{class:['tree-node__title', { '_active': _vm.isActive }],style:(`padding-left: ${_vm.level * 20 + 12}px`),on:{"click":function($event){return _vm.click(_vm.data)}}},[_vm._v(" "+_vm._s(_vm.data.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }